import { instance } from "api/apiBase";
import { FeedConnectPayload } from "api/syndicationFeed";
import { UloopPricing } from "types/landlord/partner";

interface UloopConnectionStatus {
  connected: boolean;
  pricing_model: UloopPricing | null;
  auto_add_listings: boolean;
  uloop_property_count: number;
}

export type UloopConnectPayload = FeedConnectPayload & {
  pricing_model?: UloopPricing;
};

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/uloop";

export const uloopApi = {
  getStatus: async (): Promise<UloopConnectionStatus> => {
    const { data } =
      await instance.get<UloopConnectionStatus>(BASE_ENDPOINT_URL);
    return data;
  },

  connect: async (
    payload: UloopConnectPayload
  ): Promise<UloopConnectionStatus> => {
    const { data } = await instance.post<UloopConnectionStatus>(
      BASE_ENDPOINT_URL,
      payload
    );
    return data;
  },

  update: async (payload: {
    pricing_model: UloopPricing;
  }): Promise<UloopConnectionStatus> => {
    const { data } = await instance.patch<UloopConnectionStatus>(
      BASE_ENDPOINT_URL,
      payload
    );
    return data;
  },

  disconnect: async (): Promise<UloopConnectionStatus> => {
    const { data } =
      await instance.delete<UloopConnectionStatus>(BASE_ENDPOINT_URL);
    return data;
  }
};
